import React from 'react';
import { Link } from 'react-router-dom';
import SITE from '../../../Data/siteConfig';
import logo from '../../../images/newLogo-ÜçKardeşlerTS.jpg';
import './navbarLeft.css';

const NavbarLeft = () => {
  return (
    <Link to="/" className="nav-brand" aria-label={`${SITE.name} — Anasayfa`}>
      <img src={logo} className="nav-brand-logo" alt="" />
      <span className="nav-brand-text">
        <strong>Üç Kardeşler</strong>
        <small>Teknik Servis</small>
      </span>
    </Link>
  );
};

export default NavbarLeft;
